import { tailwindVariants } from '@air/utils-tailwind';

export const TEXTAREA_ELEMENT_TAG = 'textarea';

export type TextareaSize = 'small' | 'medium' | 'large' | 'extra-large';

export const TEXTAREA_SIZE_CLASSES: { [key in TextareaSize]: string } = {
  ['extra-large']: 'text-16 text-16',
  large: 'text-16 md:text-14',
  medium: 'text-16 md:text-14',
  small: 'text-16 md:text-12',
};

export const textarea = tailwindVariants({
  base: 'w-full rounded-4 border ads:border-input border-gray-5 ads:bg-input bg-gray-1 px-2 py-2.5 ads:text-primary text-gray-12 outline-none read-only:cursor-default read-only:ads:border-input read-only:border-gray-5 read-only:ads:bg-subtle read-only:bg-gray-3 hover:ads:border-hover-input hover:border-gray-7 read-only:hover:ads:border-hover-input read-only:hover:border-gray-7 focus:ads:border-primary focus:border-blue-9 focus:ads:ring-focus focus:ring-1 focus:ring-blue-9 focus:hover:ads:border-primary focus:hover:border-blue-9 disabled:cursor-not-allowed disabled:opacity-75 disabled:hover:ads:border-input disabled:hover:border-gray-5 aria-invalid:ads:border-error aria-invalid:border-red-9 aria-invalid:ads:ring-error aria-invalid:ring-1 aria-invalid:ring-red-9',
});
